// extracted by mini-css-extract-plugin
export default {"container":"Error_container__-QF5S","status":"Error_status__3HFro","message":"Error_message__KoPyG"};